import React from 'react'
import MaterialSymbol from '../../../components/icons/material-symbol'
import { IconButton, Skeleton, Tooltip } from '@mui/material'
import IconProfileER from '../../../components/icons/icon-profile-er'
import thumbUp from './../../../assets/images/thumb.png'
import thumbDown from './../../../assets/images/thumb_down.png'
import { SemiCirclePie } from '../../influencer/profile-view/semi-circle-chart'


// type Props = {
//     title: string,
//     value: any,
//     iconName?: string,
//     mobileTitle?: boolean,
//     mobileTitleText?: string,
//     loading?:boolean,
//     className?:string,
//     tooltip?:boolean,
//     tooltipText?:string,
//     thumb?: string,
//     semiCircle?: string,
//     browserData?:any,
//     handlePointClick?: any,
//     SemiCircleHeight?: any,
//     SemiCircleWidth?: any,
//     SemiCircleSize?:any,
//     SemiCircleInnerSize?:any,
//     thumbPosition?:any,
//     thumbData?:any,
//     iconImage?: React.ComponentType<any>,
//     avatarPercentage?: number, // 0 to 100
//   avatarUrl?: string,
//   data?:any,
//   colors?:[]
// }

// const FollowerCard = ({ tooltip, tooltipText,className, title, value, iconName, mobileTitle, mobileTitleText, loading, iconImage, thumb, semiCircle, browserData, handlePointClick, SemiCircleWidth, SemiCircleHeight, SemiCircleSize="80%", SemiCircleInnerSize="30%", thumbData, thumbPosition,avatarPercentage = 0, colors, data, // 0 to 100
//   avatarUrl, }: Props) => {
//   return (
//     <div className={`card-follower ${className ? className : ""} `}>
//         <div className='card-follower__left w-100'>
//         <span className='card-follower__title'>{mobileTitle ? mobileTitleText : title}</span>
//             {loading ? <Skeleton /> : 
//             <><div className='d-flex'>
//               <span className='card-follower__value'>{value}</span>
//               {thumbPosition === 'positive' &&
//               <span className='ms-auto d-flex align-items-center'>
//                 <img src={thumbUp} alt="thumb" />
//                 <span className='fs-14 ms-1'>Excellent</span>
//               </span>
//               }
//               {thumbPosition === 'negative' &&
//               <span className='ms-auto d-flex align-items-center'>
//                 <img src={thumbDown} alt="thumb" />
//                 <span className='fs-14 ms-1'>Not good</span>
//               </span>
//               }
//             </div>
//             {(semiCircle === 'true') &&
//               <div className='thumb-data'>
//               {thumbPosition === 'up' &&
//               <span className='ms-auto d-flex align-items-start'>
//                 <img className='thumb-data-img' src={thumbUp} alt="thumb" />
//                 <span className='fs-14 ms-1 thumb-data-info'>{thumbData}</span>
//               </span>
//               }
//               {thumbPosition === 'down' &&
//               <span className='ms-auto d-flex align-items-start'>
//                 <img src={thumbDown} alt="thumb" className='thumb-data-img' />
//                 <span className='fs-14 ms-1 thumb-data-info'>{thumbData}</span>
//               </span>
//               }
//               </div>
//             }

//            </>
            
//             }
//         </div>
//          {(semiCircle === 'true') &&
//             <div className='card-follower-right'>
//               <SemiCirclePie
//   data={data}
//   colors={colors}
//   width={SemiCircleWidth}
//   height={SemiCircleHeight}
//   innerRadius={30}
//   outerRadius={70}
//   gap={4}
//   rounded={true}
//   avatarPercentage={avatarPercentage}
//   avatarUrl={avatarUrl}
// />
//             </div>
//             }
//         {tooltip && 
//           <Tooltip title={tooltipText} arrow>
//               <IconButton className='p-0'>
//                   <MaterialSymbol iconName='info' fontweight='200' />
//               </IconButton>
//           </Tooltip>
//           }
//         {iconName &&
//           <MaterialSymbol iconName={iconName} fontweight='200' className='card-follower__icon' />
//         }
//         {/* {
//           iconImage &&
//           <IconProfileER className='card-follower__icon' />
          
//         } */}
//     </div>
//   )
// }

// export default FollowerCard
type Props = {
  title: string,
  subTitle?: string,
    value: any,
    iconName?: string,
    mobileTitle?: boolean,
    mobileTitleText?: string,
    loading?:boolean,
    className?:string,
    tooltip?:boolean,
    tooltipText?:string,
    thumb?: string,
    semiCircle?: string,
    browserData?:any,
    handlePointClick?: any,
    SemiCircleHeight?: any,
    SemiCircleWidth?: any,
    SemiCircleSize?:any,
    SemiCircleInnerSize?:any,
    thumbPosition?:any,
    thumbData?:any,
    iconImage?: React.ComponentType<any>,
    avatarPercentage?: number, // 0 to 100
  avatarUrl?: string,
  data?:any,
  colors?:[],
  variant?:string 
}
const FollowerCard = ({
  tooltip,
  tooltipText,
  className,
  title,
  subTitle,
  value,
  iconName,
  mobileTitle,
  mobileTitleText,
  loading,
  iconImage,
  thumb,
  semiCircle,
  browserData,
  handlePointClick,
  SemiCircleWidth,
  SemiCircleHeight,
  SemiCircleSize = "80%",
  SemiCircleInnerSize = "30%",
  thumbData,
  thumbPosition,
  avatarPercentage = 0,
  colors,
  data,
  avatarUrl,
  variant,
}: Props & { variant?: | 'semi-circle-variant' | 'half-half' | 'minimal' }) => {
 
  const renderThumb = () => {
    if (!thumbPosition) return null;
    const thumbSrc = thumbPosition === 'positive' || thumbPosition === 'up' ? thumbUp : thumbDown;
    const thumbLabel = thumbPosition === 'positive' ? 'Excellent' : thumbPosition === 'negative' ? 'Not good' : thumbData;

    return (
      <span className='thumb-data'>
        <img src={thumbSrc} alt="thumb" className='thumb-data-img' />
        <span className='fs-14 ms-1 thumb-data-info'>{thumbLabel}</span>
       
      </span>
    );
  };

  const renderChart = () => {
    if (variant !== "semi-circle-variant" ) return null;
    return (
      <div className='card-follower-right'>
        <SemiCirclePie
          data={data}
          colors={colors}
          width={SemiCircleWidth}
          height={SemiCircleHeight}
          innerRadius={30}
          outerRadius={70}
          gap={4}
          rounded={true}
          avatarPercentage={avatarPercentage}
          avatarUrl={avatarUrl}
        />
      </div>
    );
  };
  const finalVariant = variant || 'default';
  const renderContent = () => {
    switch (finalVariant) {
      case 'semi-circle-variant':
        return (
          <>
          <div className='card-follower__left w-100 semi-circle-variant'>
            <div className='d-flex justify-content-between align-items-center'>
              <span className='card-follower__title'>{title}</span>
            </div>
            <span className='card-follower__value mt-1'>{value} 
              {subTitle && (
                <div className='card-follower__subtitle'>
                  {subTitle}
                </div>
              )}
            </span>
            {renderThumb()}
          
          </div>
            {renderChart()}
          </>
        );

      case 'minimal':
        return (
          <div className='minimal-variant d-flex align-items-center justify-content-between'>
            <span className='card-follower__value'>{value}</span>
            {renderThumb()}
          </div>
        );

      case 'half-half':
        return (
          <div className='half-half-variant'>
            <div className='half-half-variant-left d-flex justify-content-between align-items-start'>
              <div>
                <span className='card-follower__title fs-18'>{title}</span>
                <div className='card-follower__value fs-32 fw-bold'>{value}  {subTitle && (
                <div className='card-follower__subtitle'>
                  {subTitle}
                </div>
              )}</div>
              </div>
              
            </div>
            <div className={`half-half-variant-right ${thumbPosition === 'up' ? "positive" : "negative"}`}>
              {renderThumb()}
              
            </div>
            {/* {renderChart()} */}
          </div>
        );

      default:
        return (
          <>
            <div className='card-follower__left w-100'>
              <span className='card-follower__title'>{mobileTitle ? mobileTitleText : title}</span>
              {loading ? (
                <Skeleton />
              ) : (
                <>
                  <div className='d-flex'>
                    <span className='card-follower__value d-flex'>{value} {subTitle && (
                  <span style={{fontSize:'12px',
    alignSelf: 'flex-end',
    paddingLeft: '4px',
    paddingBottom: '2px',
    fontWeight: 'normal'}}>
                    {subTitle}
                  </span>
              )}</span>
                    {thumbPosition === 'positive' && renderThumb()}
                    {thumbPosition === 'negative' && renderThumb()}
                  </div>
                  {semiCircle === 'true' && (thumbPosition === 'up' || thumbPosition === 'down') && (
                    <div className='thumb-data'>{renderThumb()}</div>
                  )}
                </>
              )}
            </div>
            
          </>
        );
    } 
  };

  return (
    <div className={`card-follower ${className || ''} ${variant}-variant-sec`}>
      {renderContent()}
      {tooltip && (
        <Tooltip title={tooltipText} arrow>
          <IconButton className='p-0'>
            <MaterialSymbol iconName='info' fontweight='200' />
          </IconButton>
        </Tooltip>
      )}
      {iconName && (
        <MaterialSymbol iconName={iconName} fontweight='200' className='card-follower__icon' />
      )}
    </div>
  );
};
export default FollowerCard;